export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8349.012fdc6c.jpg";